<template>
  <a-select
    show-search
    :filter-option="false"
    :value="value"
    :disabled="disabled"
    :placeholder="placeholder"
    @change="handleChange"
    @search="handleSearch"
  >
    <a-select-option v-for="item in filteredList" :key="item.id" :value="item.id">
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>

<script>
/**
 * 学校搜索选择组件
 * 支持搜索过滤，选中后自动重置显示全部列表
 */
export default {
  name: 'SchoolSearchSelect',
  props: {
    // 选中的值
    value: {
      type: [String, Number],
      default: undefined
    },
    // 学校列表数据
    list: {
      type: Array,
      default: () => []
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 占位文本
    placeholder: {
      type: String,
      default: '请选择学校'
    }
  },
  data() {
    return {
      searchKeyword: '' // 搜索关键词
    }
  },
  computed: {
    // 根据搜索关键词过滤后的列表
    filteredList() {
      if (!this.searchKeyword) {
        return this.list
      }
      return this.list.filter(item => {
        return item.name && item.name.includes(this.searchKeyword)
      })
    }
  },
  methods: {
    /**
     * 搜索学校
     * @param {string} value - 搜索关键词
     */
    handleSearch(value) {
      this.searchKeyword = value
    },
    /**
     * 选中学校后重置搜索，显示全部列表
     * @param {string|number} value - 选中的值
     */
    handleChange(value) {
      this.searchKeyword = ''
      this.$emit('change', value)
      this.$emit('input', value)
    }
  }
}
</script>
